import PageTemplate from '../components/PageTemplate';

const EarthPage = () => (
  <PageTemplate
    page="earth"
    pageName="Earth"
    tagline="Invest in the world we all share."
    icon="🌍"
    accentColor="#43A047"
    about={{
      title: 'Stewardship: Investing in Our Shared Home',
      paragraph1: 'The earth is our most fundamental inheritance and our most urgent investment. How we treat our planet determines the wealth of every generation to come.',
      paragraph2: 'From sustainable living practices to environmental activism, from green energy to conscious consumption — every act of stewardship is a compound investment in humanity\'s future.',
      points: [
        'Sustainable living and zero-waste practices',
        'Conservation and biodiversity protection',
        'Green energy and regenerative agriculture',
        'Climate advocacy and environmental justice',
      ]
    }}
  />
);

export default EarthPage;
